module.exports = __webpack_public_path__ + "static/923721462.d8206eaa.jpg";